import React from "react";

export const AddressLinkText = ({line1, line2, city, state, zip}) => {
    const trimmedLine1 = line1?.trim() || undefined
    const trimmedLine2 = line2?.trim() || undefined
    const trimmedCity = city?.trim() || undefined
    const trimmedState = state?.trim() || undefined
    const trimmedZip = zip?.trim() || undefined

    const isMappable = [trimmedLine1, trimmedCity, trimmedState, trimmedZip].some(s => typeof s !== "undefined")
    const mapQuery = [trimmedLine1, trimmedLine2, trimmedCity, trimmedState, trimmedZip].filter(s => s).join('+')

    const mapLink = /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent) && !window.MSStream
        ? `https://maps.apple.com/?q=${mapQuery}`
        : `https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=${mapQuery}`

    const hasLine1OrLine2 = trimmedLine1 || trimmedLine2
    const hasCityOrState = trimmedCity || trimmedState
    const hasCityOrStateOrZip = hasCityOrState || trimmedZip

    const addressToRender = <>
        {trimmedLine1}
        {trimmedLine1 && trimmedLine2 && <> </>}
        {trimmedLine2}
        {hasLine1OrLine2 && hasCityOrState && <>, </>}
        {trimmedCity}
        {trimmedCity && trimmedState && <>, </>}
        {trimmedState}
        {hasCityOrStateOrZip && trimmedZip && <> </>}
        {trimmedZip}
    </>

    const linkStyle = {
        color: 'blue',
        textDecoration: 'none'
    }

    return isMappable
        ? <a style={linkStyle} href={mapLink} target='_blank' rel="noopener noreferrer">{addressToRender}</a>
        : <span>{addressToRender}</span>
}
